module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAAAXNSR0IArs4c6QAAANFJREFUOBFjYBgFtA4BZmQLKisrt9rY2CwF4gZbW1uzw4cPL//582ckkL5KDH3kyJErMPMYYQwQXVFR8R+Z39HRgSKPLEeIzURIAbnyQ89gFmK8CorU////e4HUMjIybmtvb/cmpI+ooIAZCjIMmY3PcBQXg1yDpHErPo0gOXw+QTGYGC8iW4bkCAyfEBUUyIYRyybKYFAQIRlIMIhAalGCAkkzCpPUIAJpJsrFKLYQyaGPwcBCyBjkIGJpfGGPEsZMTEzg0o1YmpywJzIkB0AZADLLbRCvIPvMAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/Align/layout_AlignJustify_disabled.png
// module id = 304
// module chunks = 0